import styled from "styled-components";
import { theme } from "..";
export const HeaderMenuItem = styled.div `
  float: left;
  color: #444;
  height: ${theme.header.lineHeight};
  line-height: ${theme.header.lineHeight};
  padding: 0 10px;
  min-width: ${theme.header.lineHeight};
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;

  cursor: pointer;

  :hover {
    color: "#444";
    background: rgba(0, 0, 0, 0.05);
  }
`;
//# sourceMappingURL=HeaderMenuItem.js.map